<section class="invoice-form">
  <app-form-header [menuDefinition]="menuDefinition" [showSave]="canManageInvoices" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="invoice-form__form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      @if (dataContext) {
        <div class="astral-stack-l">
          <section class="astral-section-surface astral-form-stack">
            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <app-text-box-readonly
                [caption]="'INVOICE.STATUS'"
                [text]="dataContext.statusCaption"
                [translateText]="true"
              ></app-text-box-readonly>
              @if (isAttested) {
                <app-text-box-readonly
                  [caption]="'INVOICE.INVOICE_NUMBER'"
                  [text]="dataContext.invoiceNumber"
                  [helpText]="'INVOICE.HELP_TEXT.INVOICE_NUMBER'"
                ></app-text-box-readonly>
              }
              @if (!isAttested) {
                <astral-date-picker
                  [control]="form.controls['invoiceDate']"
                  [model]="dataContext.invoiceDate"
                  [label]="'INVOICE.CREATED'"
                  [isRequired]="true"
                ></astral-date-picker>
              }
              @if (isAttested) {
                <astral-date-picker
                  [control]="form.controls['invoiceDate']"
                  [model]="dataContext.invoiceDate"
                  [label]="'INVOICE.CREATED'"
                  [readonly]="true"
                ></astral-date-picker>
              }
            </astral-layout-group>
            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <astral-date-picker
                [control]="form.controls['dueDate']"
                [label]="'INVOICE.DUE_DATE'"
                [model]="dataContext.dueDate"
                [isRequired]="true"
              ></astral-date-picker>
              <astral-date-picker
                [control]="form.controls['periodFrom']"
                [label]="'INVOICE.PERIOD_FROM'"
                [model]="dataContext.periodFrom"
                [readonly]="true"
              ></astral-date-picker>
              <astral-date-picker
                [control]="form.controls['periodTo']"
                [label]="'INVOICE.PERIOD_TO'"
                [model]="dataContext.periodTo"
                [readonly]="true"
              ></astral-date-picker>
              @if (dataContext.hasDebtCollectionAgency) {
                @if (dataContext.sentToDebtCollection?.hasValue()) {
                  <app-text-box-readonly
                    [caption]="'INVOICE.SENT_TO_DEBT_COLLECTION'"
                    [text]="dataContext.sentToDebtCollection"
                  ></app-text-box-readonly>
                }
              } @else {
                <astral-date-picker
                  [control]="form.controls['sentToDebtCollection']"
                  [helpText]="'INVOICE.HELP_TEXT.SENT_TO_DEBT_COLLECTION'"
                  [label]="'INVOICE.SENT_TO_DEBT_COLLECTION'"
                  [model]="dataContext.sentToDebtCollection"
                ></astral-date-picker>
              }
              <astral-date-picker
                [control]="form.controls['defermentDate']"
                [label]="'INVOICE.DEFERMENT_DATE'"
                [model]="dataContext.defermentDate"
                [showEmptyReadOnly]="false"
                [readonly]="true"
              ></astral-date-picker>
            </astral-layout-group>
          </section>
          <section class="astral-section-surface astral-form-stack">
            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <app-text-box-readonly [caption]="'INVOICE.RECIPIENT_NAME'" [text]="dataContext.invoiceRecipient"></app-text-box-readonly>
              <astral-select
                [control]="form.controls['deliveryMethod']"
                [itemsSource]="invoiceDeliveryMethods"
                [helpText]="'INVOICE.HELP_TEXT.DELIVERY_METHOD'"
              ></astral-select>
              @if (hasDeliveryMethodEmail) {
                <astral-input
                  [control]="form.controls['debtorEmailAddress']"
                  [helpText]="'INVOICE.HELP_TEXT.EMAIL'"
                  [type]="'email'"
                  [inputMode]="'email'"
                ></astral-input>
              }
            </astral-layout-group>
            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <app-text-box-readonly [caption]="'COMMON.COMPANY'" [text]="dataContext.companyNumberAndName"></app-text-box-readonly>
              @if (isAttested) {
                <app-text-box-readonly
                  [caption]="'INVOICE.OCRNUMBER'"
                  [text]="dataContext.ocrNumber"
                  [helpText]="'INVOICE.HELP_TEXT.OCRNUMBER'"
                ></app-text-box-readonly>
              }
              <app-text-box-readonly [caption]="'COMPANY.BANK_GIRO'" [text]="dataContext.bankGiroNumber"></app-text-box-readonly>
            </astral-layout-group>
          </section>
          <section class="astral-section-surface astral-form-stack">
            <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
              <app-money-box [control]="form.controls['netAmount']"></app-money-box>
              <app-money-box [control]="form.controls['vatAmount']"></app-money-box>
              <app-money-box [control]="form.controls['rounding']"></app-money-box>
              <app-money-box [control]="form.controls['amount']"></app-money-box>
              <app-money-box [control]="form.controls['remainingAmount']"></app-money-box>
              <astral-date-picker
                [control]="form.controls['fullyRegulated']"
                [label]="'INVOICE.FULLY_REGULATED'"
                [model]="dataContext.fullyRegulated"
                [showEmptyReadOnly]="false"
                [readonly]="true"
              ></astral-date-picker>
            </astral-layout-group>
            @if (showLabeling) {
              <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                @if (showReadOnlyLabeling) {
                  <app-text-box-readonly
                    [caption]="'LEASE_AGREEMENT.LABELING'"
                    [text]="dataContext.labeling"
                  ></app-text-box-readonly>
                }
                @if (!isAttested) {
                  <astral-input [control]="form.controls['labeling']"></astral-input>
                }
              </astral-layout-group>
            }
            <astral-input [control]="form.controls['note']" [helpText]="'INVOICE.HELP_TEXT.NOTE'"></astral-input>
          </section>
          <section class="astral-section-surface astral-stack-m">
            <app-postal-address
              [group]="form.controls['recipientAddress']"
              [mandatory]="true"
              [model]="dataContext.debtor.address"
              [nameLabel]="'ADDRESS_FORM.RECIPIENT_LABEL'"
              [showName]="true"
              [title]="'LEASE_AGREEMENT.INVOICE_ADDRESS_HEADER'"
            ></app-postal-address>
          </section>
          <div class="astral-accordion-stack">
            <astral-accordion [header]="'INVOICE_ROW.HEADER'" (stateChanged)="allowSectionInit('invoiceRows')" [allowWidthExpansion]="true">
              @if (isSectionAllowed('invoiceRows')) {
                <div>
                  <app-invoice-row-list
                    [dataContext]="rowsListDataContext"
                    (invoiceRowCreate)="invoiceRowCreated($event)"
                    (invoiceRowChange)="invoiceRowChanged($event)"
                    (invoiceRowDelete)="invoiceRowDeleted($event)"
                    (invoiceRowsReorder)="invoiceRowReordered()"
                  ></app-invoice-row-list>
                </div>
              }
            </astral-accordion>
            @if (showAppendixes || canUploadAppendixes) {
              <astral-accordion [header]="'DOCUMENT.LIST_HEADER'" (stateChanged)="allowSectionInit('appendixes')" [allowWidthExpansion]="true">
                <div class="astral-stack-m">
                  @if (canUploadAppendixes) {
                    <app-file-upload
                      [forms]="appendixes"
                      [text]="'COMMON.ATTACH_PDF_FILE'"
                      [allowedMimeTypes]="appendixMimeTypes"
                    ></app-file-upload>
                  }
                  @if (showAppendixes) {
                    <app-list-view
                      [columnDefinition]="columnDocumentsDefinition"
                      [itemsSource]="documents"
                      [contextMenuDefinition]="documentsContextMenuDefinitions"
                      [preferencesKey]="'invoice.documents'"
                    ></app-list-view>
                  }
                </div>
              </astral-accordion>
            }
            @if (showDeliveries) {
              <astral-accordion [header]="'INVOICE.DELIVERY_HEADER'" (stateChanged)="allowSectionInit('deliveries')" [allowWidthExpansion]="true">
                @if (isSectionAllowed('deliveries')) {
                  <div class="astral-stack-m">
                    <app-list-view
                      [columnDefinition]="columnDeliveriesDefinition"
                      [itemsSource]="dataContext.deliveries"
                      [preferencesKey]="'invoice.deliveries'"
                    ></app-list-view>
                    @if (showB2CInvoiceImportEvents) {
                      <div class="astral-stack-s">
                        <h5>{{ 'B2C_INVOICE_IMPORT_EVENT.CAPTION' | translate }}</h5>
                        <app-list-view
                          [columnDefinition]="columnB2CInvoiceImportEvent"
                          [itemsSource]="dataContext.b2CInvoiceImportEvents"
                          [preferencesKey]="'invoice.b2c-import-events'"
                        ></app-list-view>
                      </div>
                    }
                  </div>
                }
              </astral-accordion>
            }
            @if (showDirectDebits) {
              <astral-accordion [header]="'DASHBOARD.MENU.DIRECT_DEBIT'" (stateChanged)="allowSectionInit('directDebit')" [allowWidthExpansion]="true">
                @if (isSectionAllowed('directDebit')) {
                  <app-list-view
                    [columnDefinition]="columnDirectDebitDefinition"
                    [itemsSource]="dataContext.directDebits"
                    [preferencesKey]="'invoice.direct-debits'"
                  ></app-list-view>
                }
              </astral-accordion>
            }
            @if (showPayments) {
              <astral-accordion [header]="'PAYMENT.BG_PAYMENTS'" (stateChanged)="allowSectionInit('payments')" [allowWidthExpansion]="true">
                @if (isSectionAllowed('payments')) {
                  <app-list-view
                    [columnDefinition]="columnTransactionsDefinition"
                    [itemsSource]="dataContext.transactions"
                    [contextMenuDefinition]="transactionsMenuDefinition"
                    [preferencesKey]="'invoice.transactions'"
                  ></app-list-view>
                }
              </astral-accordion>
            }
            @if (showCreditInvoices) {
              <astral-accordion [header]="'INVOICE.CREDIT_INVOICE'" (stateChanged)="allowSectionInit('creditInvoices')" [allowWidthExpansion]="true">
                @if (isSectionAllowed('creditInvoices')) {
                  <app-list-view
                    [columnDefinition]="columnCreditInvoiceDefinition"
                    [itemsSource]="dataContext.creditInvoices"
                    [preferencesKey]="'invoice.credit-invoices'"
                    (rowClick)="onCreditInvoiceRowClicked($event)"
                  ></app-list-view>
                }
              </astral-accordion>
            }
            @if (showReminders) {
              <astral-accordion [header]="'INVOICE.REMINDERS'" (stateChanged)="allowSectionInit('reminders')" [allowWidthExpansion]="true">
                @if (isSectionAllowed('reminders')) {
                  <app-list-view
                    [columnDefinition]="columnRemindersDefinition"
                    [itemsSource]="dataContext.reminders"
                    [preferencesKey]="'invoice.reminders'"
                    (rowClick)="onReminderInvoiceRowClicked($event)"
                  ></app-list-view>
                }
              </astral-accordion>
            }
            @if (showDebtCollectionLog) {
              <astral-accordion
                [header]="'DEBT_COLLECTION.ERRAND'"
                (stateChanged)="allowSectionInit('debtCollectionLog')"
                [allowWidthExpansion]="true">
                @if (isSectionAllowed('debtCollectionLog')) {
                  <app-list-view
                    [columnDefinition]="columnDebtCollectionLogDefinition"
                    [itemsSource]="dataContext.debtCollectionLogs"
                    [preferencesKey]="'invoice.debt-collection-log'"
                  ></app-list-view>
                }
              </astral-accordion>
            }
            @if (showVerifications) {
              <astral-accordion [header]="'VERIFICATION.VERIFICATIONS'" (stateChanged)="setVerificationsVisibility($event)" [allowWidthExpansion]="true">
                <div class="astral-stack-m">
                  <app-list-view
                    [columnDefinition]="columnAccountingsDefinition"
                    [itemsSource]="dataContext.accountingTransactions"
                    [preferencesKey]="'invoice.accounting-transactions'"
                  ></app-list-view>
                  <div class="astral-stack-s">
                    <h5>{{ 'INVOICE.ACCOUNT_BALANCES' | translate }}</h5>
                    <app-list-view
                      [columnDefinition]="columnAccountingBalance"
                      [itemsSource]="dataContext.accountingBalances"
                      [preferencesKey]="'invoice.accounting-balances'"
                    ></app-list-view>
                  </div>
                </div>
              </astral-accordion>
            }
            <astral-accordion [header]="'TENANT.LIST_HEADER'" (stateChanged)="allowSectionInit('tenants')" [allowWidthExpansion]="true">
              @if (isSectionAllowed('tenants')) {
                <app-list-view
                  [columnDefinition]="columnContactsDefinition"
                  [itemsSource]="dataContext.invoiceContacts"
                  [preferencesKey]="'invoice.contacts'"
                  (rowClick)="onContactRowClicked($event)"
                ></app-list-view>
              }
            </astral-accordion>
            @if (showLeaseAgreements) {
              <astral-accordion
                [header]="'LEASE_AGREEMENT.LIST_HEADER'"
                (stateChanged)="allowSectionInit('leaseAgreements')"
                [allowWidthExpansion]="true">
                @if (isSectionAllowed('leaseAgreements')) {
                  <app-list-view
                    [columnDefinition]="columnleaseAgreementDefinition"
                    [itemsSource]="dataContext.leaseAgreements"
                    [preferencesKey]="'invoice.lease-agreements'"
                    (rowClick)="onLeaseAgreementRowClicked($event)"
                  ></app-list-view>
                }
              </astral-accordion>
            }
            @if (!dataContext.isNew) {
              <astral-accordion [header]="'LOG.HEADER'" (stateChanged)="onLogsStateChanged($event)" [allowWidthExpansion]="true">
                @if (isSectionAllowed('logs')) {
                  <app-list-view
                    [columnDefinition]="logColumnDefinition"
                    [itemsSource]="logs"
                    [preferencesKey]="'invoice.logs'"
                  ></app-list-view>
                  <section class="astral-section-surface astral-section-surface--fit-content astral-stack-m">
                    <h2 class="astral-section-heading">{{ 'INVOICE.VERIFICATION_LOG' | translate }}</h2>
                    <app-list-view
                      [columnDefinition]="verificationLogColumnDefinition"
                      [itemsSource]="verificationLogs"
                      [preferencesKey]="'invoice.verification-logs'"
                    ></app-list-view>
                  </section>
                }
              </astral-accordion>
            }
          </div>
        </div>
      }
    </form>
  }
</section>
